module.exports = __webpack_public_path__ + "static/media/user.81c451f6.jpg";